import { useState, useContext } from 'react';
import { SessionContext } from '#client/contexts/SessionContext.jsx';
import { hasPermission } from '#client/utils/helpers';
import { InlineStack, Icon, Box } from '@shopify/polaris';
import logo from '#client/assets/images/ww-logo-allcompany-black.png';
import NavLink from './NavLink';
import LocationSwitcher from './LocationSwitcher';
import HoverDropdownNavLink from './HoverDropDownNavLink';
import { ProfileIcon, MenuIcon } from '@shopify/polaris-icons';
import NotificationBell from './NotificationBell';

import './Header.css';

const Header = () => {
    const { currentUser, logout } = useContext(SessionContext);

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

    const dropdownItems = [
        ...(hasPermission(currentUser, 'settingApiKeys') ? [{ to: '/api-users', label: 'API Users' }] : []),
        ...(hasPermission(currentUser, 'settingReasonCodes') ? [{ to: '/settings', label: 'Settings' }] : []),
        ...(hasPermission(currentUser, 'jobsView') ? [{ to: '/jobs', label: 'Jobs' }] : []),
        { label: 'Print Labels', to: '/print-labels' },
        ...(hasPermission(currentUser, 'reportsView') ? [{ to: '/reports', label: 'Reports' }] : []),
        { label: 'Log Out', onClick: logout },
    ];

    return (
        <header className="header">
            <button className="hamburger-button" onClick={toggleMobileMenu}>
                <Icon source={MenuIcon} />
            </button>

            <Box className="header-logo">
                <a href="/dashboard">
                    <img src={logo} alt="Work World" />
                </a>
            </Box>

            <Box className={`header-links ${isMobileMenuOpen ? 'open' : ''}`}>
                <InlineStack wrap gap="400" blockAlign="center" style={{ textAlign: 'center' }}>
                    <NavLink to="/cycle-counts" label="Counts" requiredPermission="ccView" />
                    <NavLink to="/transfers" label="Transfers" requiredPermission="transferView" />
                    <NavLink to="/purchase-orders" label="Purchase Orders" requiredPermission="poView" />
                    <NavLink to="/program-management" label="Programs" requiredPermission="programView" />
                    <NavLink to="/inventory-adjustments" label="Inventory Adjustments" requiredPermission="adjView" />
                </InlineStack>
            </Box>

            <Box className="header-actions">
                <LocationSwitcher locations={currentUser?.locations} />
                <NotificationBell />
                <HoverDropdownNavLink label={<Icon source={ProfileIcon} />} items={dropdownItems} />
            </Box>
        </header>
    );
};

export default Header;
